const state = {
    suplierGrpLs: null,
    selSupplierGrp:null,
    appGrpLs:null,
};

const getters = {
    GET_SUPPLIER_GRP_LS: (state) => {
        return state.suplierGrpLs;
    },
    GET_APPLY_SUPPLIER_GRP_LS: (state) => {
        return state.appGrpLs;
    },
    GET_SEL_SUPPLIER_GRP: (state) => {
        return state.selSupplierGrp;
    },
};


const actions = {

    CLEAR_SUPPLIER_GRP_STORE: ({ commit }) => {
        commit('clearSupplierGrpStore');
    },
    SET_SUPPLIER_GRP_LS: ({ commit }, suppGrp) => {

        commit('saveSupplierGrpLs', suppGrp);

    },
    SET_APPLY_SUPPLIER_GRP_LS: ({ commit }, appGrpLs) => {

        commit('saveApplySupplierGrpLs', appGrpLs);

    },
    SET_SEL_SUPPLIER_GRP: ({ commit }, selSupplierGrp) => {

        commit('saveSelSupplierGrp', selSupplierGrp);

    },

};


const mutations = {
    clearSupplierGrpStore: (state) => {
        state.suplierGrpLs = null;
       state.selSupplierGrp = null;
       state.appGrpLs = null;
    },

    saveSupplierGrpLs: (state, routes) => {
        state.suplierGrpLs = routes;
    },

    saveApplySupplierGrpLs: (state, appGrpLs) => {
        state.appGrpLs = appGrpLs;
    },

    saveSelSupplierGrp: (state, selSupplierGrp) => {
        state.selSupplierGrp = selSupplierGrp;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}